import React from "react";
import "./styles.scss";

const JioPhotosIosLicences = () => {
  return (
    <>
      <div className="licences-jiophotos">
        <h1 className="licences-jiophotos-heading">
          Licenses for JioPhotos VR
        </h1>
        <strong>Unity UI Extensions for JioPhotos</strong>
        <strong>BSD-3 License </strong>
        <strong>Copyright (c) 2019 </strong>
        <h3>
          Redistribution and use in source and binary forms, with or without
          modification, are permitted provided that the following conditions are
          met:
        </h3>

        <ul className="ul_style">
          <li role="presentation">1.&nbsp;</li>
          <li className="li_style" role="presentation">
            Redistributions of source code must retain the above copyright
            notice, this list of conditions and the following disclaimer.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">2.&nbsp;</li>
          <li className="li_style" role="presentation">
            Redistributions in binary form must reproduce the above copyright
            notice, this list of conditions and the following disclaimer in the
            documentation and/or other materials provided with the distribution.
          </li>
        </ul>
        <ul className="ul_style">
          <li role="presentation">3.&nbsp;</li>
          <li className="li_style" role="presentation">
            Neither the name of the copyright holder nor the names of its
            contributors may be used to endorse or promote products derived from
            this software without specific prior written permission.
          </li>
        </ul>

        <ul className="ul_style">
          <li className="li_style" role="presentation">
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
            "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
            LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
            FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
          </li>
        </ul>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </li>
        </ul>
        <strong>Agora video SDK</strong>
        <strong>AGORA, INC. SDK LICENSE AGREEMENT</strong>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            This SDK License Agreement (the Agreement) is for the Agora, Inc.
            (Agora) software development kit and any associated tools and
            documentation made available by Agora (the SDK) to enable users to
            integrate their mobile applications with Agora proprietary voice
            call functionality. By downloading or using the SDK, you and any
            company, entity, or organization on behalf of which you are
            accepting this Agreement hereby agree to be bound by this Agreement.
            If you do not agree to this Agreement, do not download or use the
            SDK
          </li>
        </ul>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            If you are downloading, accessing. or using the SDK on behalf of a
            company, entity, or organization, then you represent and warrant
            that you are an authorized representative of such company, entity,
            or organization with the authority to bind such company, entity, or
            organization to this Agreement; and agree to be bound by this
            Agreement on behalf of such company, entity, or organization. You
            and, if applicable, such company, entity, or organization are
            referred to herein as you.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>
            {" "}
            1.In addition to those terms defined in the body of the Agreement,
            the following capitalized terms will have the meanings set forth
            below:
          </strong>
        </h3>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            API means application programming interface.
          </li>
        </ul>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            Application means any application developed by you using the SDK.
          </li>
        </ul>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            Confidential Informationâ€ means any non-public information provided
            by Agora to you that is identified as confidential or should
            reasonably be considered confidential given the nature of the
            information and the circumstances of disclosure, including, without
            limitation, technical data, product plans, and financial
            information. Confidential Information includes the SDK and the terms
            and conditions of this Agreement.
          </li>
        </ul>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            SDK Modifications means any modifications you make to sample code
            included in the SDK.  
          </li>
        </ul>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            Agora Service means Agora proprietary voice technology that allows
            developers to include voice calling functionality within their
            mobile applications using Agora APIs.
          </li>
        </ul>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            Usage Data means information, analytics, and data that Agora
            collects in connection with your use of the SDK, including, but not
            limited to, the volume and length of calls that are made using the
            Agora Service.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>2. The SDK</strong>
        </h3>
        <ul className="ul_style">
          <li className="li_style" role="presentation">
            License to You Subject to your compliance with the terms and
            conditions of the Agreement, Agora grants you a non-exclusive,
            non-transferable, and worldwide license during the Term of this
            Agreement to
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            use the object code libraries,APIs and documentation specified in
            the SDK solely to enable your Applications to access the Agora
            Service; and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            modify any sample code included within the SDK solely as necessary
            to develop your Applications.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>You will not:</strong>
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            modify or delete any copyright, trademark, or other proprietary
            notices of Agora or its licensors in the SDK;
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            reverse engineer, decompile, disassemble, or otherwise tamper with
            the SDK (except and only to the extent that any such restrictions
            are prohibited by applicable law or, with respect to OSS (as defined
            below) included in the SDK, those acts permitted under the
            applicable OSS licenses);
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(c)&nbsp;</li>
          <li role="presentation">
            use the SDK on behalf of your employer or for your employerâ€™s
            products unless your employer is bound by the terms and conditions
            of the Agreement;
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(d)&nbsp;</li>
          <li role="presentation">
            modify any of the APIs specified in the SDK or object code libraries
            included with the SDK; or
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(e)&nbsp;</li>
          <li role="presentation">
            assert (or authorize, assist, or encourage any third party to
            assert) any intellectual property infringement claim against Agora
            or any of its affiliates, customers, or licensees regarding any
            portions of the SDK you have used. Except with Agoraâ€™ prior
            written permission, you may not use Agora APIs other than as
            documented in the SDK.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>IP Rights.</strong>
        </h3>
        <h3 role="presentation">
          <strong>The Agreement does not:</strong>
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            provide you with any right or license (whether expressly, by
            implication, by estoppel, or otherwise) under any of Agoraâ€™
            intellectual property rights other than to use the SDK solely in the
            manner and solely to the extent authorized in Sections 2.1 and 2.2;
            or
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            impair the right of Agora to develop, make, use, procure, protect,
            and/or market any products or services. Agora reserves all rights
            not expressly granted to you.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Modifications to the SDK.â€¯Except for sample code included in the
            SDK or as applicable to any OSS, you may not make any modifications
            to the SDK. As between you and Agora, and subject to Agoraâ€™
            ownership of the SDK, you will own any SDK Modifications. You may
            only license or distribute SDK Modifications as part of your
            Application. You will provide all SDK Modifications to Agora and you
            hereby grant Agora a perpetual, irrevocable, non-exclusive,
            royalty-free, and worldwide license to reproduce, create derivative
            works from, distribute, publicly display, publicly perform, make,
            have made, offer for sale, sell or otherwise dispose of, import, use
            and otherwise commercialize the SDK Modifications in connection with
            Agoraâ€™ products and services, with the right to sublicense each
            and every right.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Agora reserves the right, at any time, to change the features and
            functionality of the SDK and the Agora Service without liability to
            you. Such changes might include, without limitation, disabling APIs
            or limiting API calls. Agora will use commercially reasonable
            efforts to provide you with prior notice of such changes. If you do
            not agree to the changes, your sole course of action will be to stop
            using the SDK and terminate this agreement.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Within the SDK, you may have received from Agora certain audio and
            video coding technology. This Agreement does not convey a license
            nor imply any rights to use any patents or other intellectual
            property rights of any third party.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            MPEG-LA have publicly represented having been appointed to
            administer implementation licenses on behalf of patent holders to
            audio and video coding technologies relating to MPEG-2, MPEG4, AAC,
            AVC/H.264, VC-1, MPEG-4 Visual and certain MPEG4video profiles,
            respectively. Consequently, a separate and independent license from
            one or more relevant patent holders for such use may be required and
            you shall be solely responsible to verify whether such license is
            needed in conjunction with the use of the Agora Service within your
            Application.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>3. Usage Data</strong>
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            Agora will own and retain all right, title and interest in the Usage
            Data. You acknowledge and agree that Agora may collect the Usage
            Data arising out of your use of the SDK, including for performance
            analysis, improving the Agora Service, debugging, and billing
            purposes.
          </li>
        </ul>
        <h3 role="presentation">
          <strong>4. SDK Development and Distribution </strong>
        </h3>
        <h3 role="presentation">
          <strong>Your use of the SDK must: </strong>
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            comply with any guidelines set forth in the documentation included
            with or referenced in the SDK, as updated from time to time;comply
            with any applicable laws, rules, or regulations; not access, modify,
            delete, damage, or disable the Agora Service or any other Agora
            software; and not disrupt, interfere with, or access in an
            unauthorized manner the Agora Service or any Agora software or
            servers.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Agora may (in its reasonable discretion) suspend access to the SDK
            and Agora Service at any time if Agora believes that Agora may (in
            its reasonable discretion) suspend access to the SDK and Agora
            Service at any time if Agora believes that
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            you are in breach of any obligations under the Agreement;
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            your use of the SDK poses a security risk;
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(c)&nbsp;</li>
          <li role="presentation">
            there is a bug or performance issue with your use of the SDK;
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(d)&nbsp;</li>
          <li role="presentation">
            your use of the SDK violates, misappropriates, or infringes the
            rights of Agora or a third party; or
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(e)&nbsp;</li>
          <li role="presentation">
            your use of the SDK imposes unexpected or excessive demands on the
            Agora Service.
          </li>
        </ul>
        <h3 role="presentation">
          5. THE SDK IS PROVIDED TO YOU AT NO COST, HOWEVER THE USE OF THE AGORA
          SERVICE WILL BE CHARGED TO YOU BASED ON THE RATES SET OUT ON THE AGORA
          WEBSITE WHERE YOU OBTAINED THE SDK, SEE ALSO HTTP://AGORA.IO/.
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            AGORA RESERVES THE RIGHT TO INSTITUTE A FEE FOR THE USE OF THE SDK
            OR TO CHANGE THE RATES TO ACCESS THE AGORA SERVICE, AND WILL PROVIDE
            YOU WITH PRIOR NOTICE OF ANY SUCH CHANGES.
          </li>
        </ul>
        <h3 role="presentation">6. Open Source</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Agora Use of Open Source Certain components of the SDK may be
            covered by open source software (OSS) licenses. To the extent
            required by the license for any OSS:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            the terms of such license will apply to such OSS instead of the
            terms of the Agreement; and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            any restrictions prohibited by such license that are contained in
            the Agreement will not apply to such OSS.
          </li>
        </ul>
        <h3 role="presentation">Your Use of Open Source You will:</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            comply with all applicable OSS licensing terms and obligations
            (including any notice and attribution requirements), and cooperate
            with all reasonable requests by Agora to verify such compliance;
          </li>{" "}
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            not use any OSS in the Applications in such a way that would
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(i)&nbsp;</li>
          <li role="presentation">
            cause the non-OSS portions of any Agora software (including the SDK)
            to be subject to any OSS licensing terms or obligations, or
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(ii)&nbsp;</li>
          <li role="presentation">
            purport to require Agora (or its agents) to disclose or make
            available any of the keys, authorization codes, methods, procedures,
            data or other information related to Agora technology; and not use
            any OSS in the Applications that is licensed under the GPLv3,
            LGPLv3, Affero GPLv3, or Sleepycat OSS licenses.
          </li>
        </ul>
        <h3 role="presentation">
          7. Agora disclaims any confidentiality obligations or use restrictions
          related to any information or materials that you may provide to Agora,
          including anything related to the SDK, SDK Modifications,
          Applications, or any future products or services of Agora. Any such
          information and materials will be non-confidential, and if you provide
          any such information or materials to Agora, you grant Agora a
          perpetual, irrevocable, non-exclusive, royalty-free, and worldwide
          license to implement, use, modify or otherwise exploit, in any way,
          your idea, suggestion or materials (or any part thereof).
        </h3>
        <h3 role="presentation">8. Term and Termination</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            The term of the Agreement will continue until terminated in
            accordance with Section 8.2 (the Term). Either you or Agora may
            terminate the Agreement at any time by sending notice to the other
            party.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Effects of Termination.â€¯Upon termination of the Agreement: (i)
            Agora may immediately disable your use of the SDK and the Agora
            Service; (ii) you will immediately cease using the SDK and delete
            all copies you have in your possession or under your control; and
            (iii) you will immediately pay Agora all unpaid fees that accrued
            prior to the termination date, if any. This section and Sections 2
            2.4, 3, 6-7, and 9-13 will survive termination of the Agreement.
          </li>
        </ul>
        <h3 role="presentation">
          9.General Obligation. You, as a recipient of Confidential Information,
          will{" "}
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            hold the Confidential Information in strict confidence;
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            protect and safeguard the confidentiality of the Confidential
            Information with at least the same degree of care as you protect and
            safeguard your own confidential and proprietary information (but in
            no event with less than a reasonable degree of care);
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(c)&nbsp;</li>
          <li role="presentation">
            immediately notify Agora of any unauthorized access, use, or
            disclosure of any of Confidential Information; and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(d)&nbsp;</li>
          <li role="presentation">
            cooperate with Agora efforts to prevent further breaches of the
            Agreement.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Disclosure to Representatives.In addition to the obligations in
            Section 1, the receiving party will only disclose or disseminate the
            disclosing party Confidential Information to its employees and
            contractors (Representatives) who have a need to know and who have
            signed written agreements with (or are otherwise bound by
            confidentiality obligations owed to) the receiving party that
            require or permit such individuals to use, disclose, and protect the
            disclosing party Confidential Information only in a manner
            consistent with the provisions of the Agreement. The receiving party
            will be liable to the disclosing party for any failure by any
            Representatives to comply with obligations set forth in the
            Agreement.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Press Releases You may not issue any press releases or make any
            other public statements about the Agreement without Agora prior
            written approval.
          </li>
        </ul>
        <h3 role="presentation">
          10. Disclaimer of Warranties AGORA IS PROVIDING YOU WITH THE SDK AND
          ACCESS TO THE AGORA SERVICE â€œAS ISâ€ WITHOUT WARRANTIES OF ANY KIND,
          AND YOUR USE OF THE SDK IS AT YOUR OWN RISK. TO THE GREATEST EXTENT
          PERMITTED BY LAW, AGORA AND ITS LICENSORS EXPRESSLY DISCLAIM ANY AND
          ALL WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING ANY WARRANTIES
          REGARDING ACCURACY, OPERABILITY, USE, NON-INFRINGEMENT, TITLE,
          MERCHANTABILITY, AND FITNESS FOR A PARTICULAR PURPOSE.
        </h3>
        <h3 role="presentation">
          11.Limitation of Liability EXCEPT WITH RESPECT TO INDEMNIFICATION AND
          CONFIDENTIALITY OBLIGATIONS, AND TO THE GREATEST EXTENT PERMITTED BY
          LAW, NEITHER PARTY WILL BE LIABLE TO THE OTHER PARTY UNDER ANY THEORY
          OF LIABILITY FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR
          EXEMPLARY DAMAGES (EVEN IF SUCH PARTY HAS BEEN ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES AND/OR SUCH DAMAGES ARE FORESEEABLE)
          ARISING OUT OF OR RELATED TO THE AGREEMENT, INCLUDING, BUT NOT LIMITED
          TO, ANY LOSS OF REVENUE OR ANTICIPATED PROFITS OR LOST BUSINESS. IN NO
          EVENT WILL AGORA LIABILITY TO YOU ARISING OUT OF OR RELATED TO THE
          AGREEMENT EXCEED $50.00.
        </h3>
        <h3 role="presentation">
          12.To the greatest extent permitted by law, you will indemnify,
          defend, and hold harmless Agora and its officers, directors,
          employees, and agents from and against any and all third party claims,
          demands, damages, liabilities, costs, and
        </h3>
        <h3 role="presentation">
          expenses (including reasonable attorneys fees and court costs) arising
          out of or related to:
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            your use of the SDK and the Agora Service;
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            any third party use of your Applications; and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(c)&nbsp;</li>
          <li role="presentation">
            your breach of the Agreement or any failure by any of your
            affiliates to comply with any of the terms and conditions of the
            Agreement. Agora will use commercially reasonable efforts to provide
            you with prompt notification of any claim for which Agora seeks an
            indemnity, but Agora failure to provide such prompt notice will not
            limit your obligation to indemnify Agora unless you have been
            materially harmed by such failure of prompt notice. Agora will
            cooperate in your defense of any claim, at your sole expense. You
            may not settle any claim against Agora in a manner that adversely
            affects Agora without Agora prior written consent, which consent
            will not be unreasonably withheld, conditioned, or delayed. Agora
            may participate in the defense of a claim through counsel of its own
            choice at its own expense; provided, however, that if Agora
            reasonably determines that you are unwilling or unable to defend the
            interests of Agora, then Agora may assume the defense against any
            claims at your expense. Agora will not settle any claim for which
            you are obligated to indemnify Agora without your prior written
            consent, which consent will not be unreasonably withheld,
            conditioned, or delayed.
          </li>
        </ul>
        <h3 role="presentation">13. General Legal Terms</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            You may not assign or transfer the Agreement (or any of your rights
            or obligations under the Agreement) without
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">Agora prior written consent, and</li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            where consent has been granted, by ensuring that any assignee or
            transferee agrees to be bound by the Agreement in the same manner as
            you (including with respect to any intellectual property rights).
            Any attempted assignment or transfer without complying with the
            preceding sentence will be void. Agora may freely assign or transfer
            the Agreement. The Agreement inures to the benefit of and is binding
            upon the parties and their respective legal representatives,
            successors, and permitted assigns.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            If you are using the SDK on behalf of your employer or for your
            employer products, you represent, warrant, and covenant that you
            have the right, power, and authority to enter into the Agreement on
            behalf of your employer.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Electronic Communications.You consent to receive communications from
            Agora electronically. Agora will communicate with you by email, and
            you acknowledge that all agreements, notices, disclosures, and other
            communications that Agora provides to you electronically will
            satisfy any legal requirement that such communications be in
            writing.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Entire Agreement; Amendments.The Agreement supersedes all prior
            discussions and writings regarding and constitutes the entire
            agreement between the parties with respect to the SDK. The parties
            may only amend the Agreement in writing.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            You will not (whether directly or indirectly) export or re-export
            the SDK to:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            any countries that are subject to US export restrictions (such as,
            by way of example and not limitation, Iran, North Korea, Sudan, and
            Syria);
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            any third party who will utilize the SDK for prohibited end uses
            (such as, by way of example and not limitation, for the design,
            development or production of nuclear, chemical or biological
            weapons); or
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(c)&nbsp;</li>
          <li role="presentation">
            any third party who has been prohibited from participating in U.S.
            export transactions by any federal agency of the U.S. government
            (such as someone on the U.S. Treasury Departmentâ€™s list of
            Specially Designated Nationals or the U.S. Department of Commerce
            Denied Persons List or Entity List).
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Governing Law and Venue The Agreement is to be governed by and
            construed in accordance with the laws of the United States and the
            State of California, excluding its conflict of law principles. You
            and Agora will:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            bring any disputes arising out of or related to the Agreement
            exclusively in a state or federal court located in Santa Clara
            County, Texas; and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            submit to the personal jurisdiction of such courts.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Government End Users The SDK and any associated documentation are
            â€œCommercial Items,â€ as such term is defined at 48 C.F.R. 2.101,
            consisting of â€œCommercial Computer Softwareâ€ and â€œCommercial
            Computer Software Documentation,â€ as such terms are used in 48
            C.F.R. 12.212 or 48 C.F.R. 227.7202 (as applicable). Consistent with
            48 C.F.R. Â§12.212 or 48 C.F.R. Â§227.7202-1 through 227.7202-4 (as
            applicable), the Commercial Computer Software and Commercial
            Computer Software Documentation are being licensed to U.S.
            Government end-users only
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">as Commercial Items, and</li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            with those rights that are granted to all other end-users under the
            Agreement.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Irreparable Harm You agree that any actual or threatened breach of
            the Agreement by you would cause immediate and irreparable harm to
            Agora, the value of which would be difficult or impossible to
            determine and for which monetary damages would be inadequate
            compensation. Accordingly, in addition to any other remedies (and
            notwithstanding Section 6), Agora will be entitled to obtain
            injunctive relief and/or specific performance from any court of
            competent jurisdiction to prevent any such breaches and you
            expressly waive:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            the defense that monetary damages would be adequate compensation for
            Agora;
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            the defense that the harm to you and/or to others would outweigh the
            harm to Agora; and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(c)&nbsp;</li>
          <li role="presentation">
            any requirement that Agora post a bond or other security.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            To be valid, all notices permitted or required under the Agreement
            must be sent in writing by a party as follows (unless a party
            changes such information by giving notice in accordance with this
            section):
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            if to you, by Agora via email to the address associated with your
            developer account, and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            if to Agora, by you via certified mail to Agora, Inc. 378 Cambridge
            Ave, Suite M, Palo Alto, CA 94036, attn.: Legal Department. Notices
            will be deemed given
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(i)&nbsp;</li>
          <li role="presentation">if to you, when emailed, and</li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(ii)&nbsp;</li>
          <li role="presentation">if to Agora, on receipt by Agora.</li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            The Agreement does not confer any third party beneficiary rights
            (except as set forth in Section 12) and does not create a joint
            venture, agency, partnership, or other form of joint enterprise
            between the parties. Except as expressly provided herein, neither
            party has the right, power, or authority to create any obligation or
            duty, express or implied, on behalf of the other. Except as set
            forth in Section 12, there are no intended third party beneficiaries
            of the Agreement.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Severability, Waiver, and Interpretation If any provision of the
            Agreement is found to be unenforceable or invalid, such
            unenforceability or invalidity will not render the Agreement
            unenforceable or invalid as a whole and, in such event, such
            provision is to be changed and interpreted so as to best accomplish
            the objectives of such unenforceable or invalid provision within the
            limits of applicable law. No waiver of any breach of the Agreement
            will constitute a waiver of any other breach. In construing or
            interpreting the terms of the Agreement: (a) the headings in the
            Agreement are for convenience only, and are not to be considered,
            and (b) no presumption is to operate in either party favor as a
            result of its counsel role in drafting the Agreement.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Representation by Counsel You represent that you have had the
            opportunity to review the Agreement with legal counsel of your
            choosing prior to entering into the Agreement even if you have
            chosen not to seek such counsel.
          </li>
        </ul>
        <h3 role="presentation">14. Agora Allstar Program</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            The Agora Allstar Program (the Programâ€) is a developer and
            customer advocacy program in which you are automatically enrolled
            when you register for an account through the Agora Website. You will
            earn points when you are opting in to participate in Challenges that
            are part of the program, and use the points to redeem any awards
            available on the Agora Allstar Program site.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Requirements. To qualify for Program Awards, you will need to have
            an active Agora Account and be enrolled and play an active role in
            the plan.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Limitations. Program Awards may be changed, cancelled, limited in
            number or otherwise removed from the program without notice and/or
            available for a limited time only or while supplies last. Some
            Program Awards may be available in limited geographies and limited
            languages. Agora may substitute Program Awards with a benefit of
            equal or greater value in the event supplies of a Program Awards are
            exhausted.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Right to cancel, terminate, modify or suspend. Agora may, in its
            sole discretion, cancel, terminate, modify or suspend the Program,
            Program terms or any Program Awards, in whole or in part. A Program
            Award may be withheld, reduced, or terminated or you may be removed
            from the Program, at any time and in the sole discretion of Agora.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Releases. As a condition of your participation in the Program, you
            agree to release and disclaim Agora from and against any and all
            liability, claims or actions of any kind whatsoever for injuries,
            damages, or losses to persons or property which may be sustained in
            connection with participating in any aspect of the Program, the
            receipt, ownership or use of any Program Awards, or while preparing
            for, participating in or traveling to or from any Program
            Awards-related activity (if applicable) or any typographical or
            other error in the Program terms and conditions. Agora makes no
            representations or warranties of any kind concerning the appearance,
            safety or performance of any Program Awards, except for any express
            manufacturerâ€™s warranty as may be included with the Program
            Awards. Program Awards recipients bear all risk of loss or damage to
            any goods received as Program Awards.
          </li>
        </ul>
        <h1 role="presentation">
          Graphy, OpenSans, VideoUnlitShader.shader, SIL OPEN FONT, XR Legacy
          Input Helpers
        </h1>
        <h3 role="presentation">Apache License 2.0</h3>
        <h3 role="presentation">Version 2.0, January 2004 </h3>
        <h3 role="presentation">http://www.apache.org/licenses/</h3>
        <h3 role="presentation">
          {" "}
          TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION{" "}
        </h3>
        <h3 role="presentation">1. Definitions</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            "License" shall mean the terms and conditions for use, reproduction,
            and distribution as defined by Sections 1 through 9 of this
            document.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            "Licensor" shall mean the copyright owner or entity authorized by
            the copyright owner that is granting the License.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            "Legal Entity" shall mean the union of the acting entity and all
            other entities that control, are controlled by, or are under common
            control with that entity. For the purposes of this definition,
            "control" means
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(i)&nbsp;</li>
          <li role="presentation">
            the power, direct or indirect, to cause the direction or management
            of such entity, whether by contract or otherwise, or{" "}
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(ii)&nbsp;</li>
          <li role="presentation">
            ownership of fifty percent (50%) or more of the outstanding shares,
            or{" "}
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(iii)&nbsp;</li>
          <li role="presentation">beneficial ownership of such entity.</li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            "You" (or "Your") shall mean an individual or Legal Entity
            exercising permissions granted by this License."Source" form shall
            mean the preferred form for making modifications, including but not
            limited to software source code, documentation source, and
            configuration files. "Object" form shall mean any form resulting
            from mechanical transformation or translation of a Source form,
            including but not limited to compiled object code, generated
            documentation, and conversions to other media types. "Work" shall
            mean the work of authorship, whether in Source or Object form, made
            available under the License, as indicated by a copyright notice that
            is included in or attached to the work (an example is provided in
            the Appendix below).
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            "Derivative Works" shall mean any work, whether in Source or Object
            form, that is based on (or derived from) the Work and for which the
            editorial revisions, annotations, elaborations, or other
            modifications represent, as a whole, an original work of authorship.
            For the purposes of this License, Derivative Works shall not include
            works that remain separable from, or merely link (or bind by name)
            to the interfaces of, the Work and Derivative Works thereof.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Contribution" shall mean any work of authorship, including the
            original version of the Work and any modifications or additions to
            that Work or Derivative Works thereof, that is intentionally
            submitted to Licensor for inclusion in the Work by the copyright
            owner or by an individual or Legal Entity authorized to submit on
            behalf of the copyright owner. For the purposes of this definition,
            "submitted" means any form of electronic, verbal, or written
            communication sent to the Licensor or its representatives, including
            but not limited to communication on electronic mailing lists, source
            code control systems, and issue tracking systems that are managed
            by, or on behalf of, the Licensor for the purpose of discussing and
            improving the Work, but excluding communication that is
            conspicuously marked or otherwise designated in writing by the
            copyright owner as "Not a Contribution." "Contributor" shall mean
            Licensor and any individual or Legal Entity on behalf of whom a
            Contribution has been received by Licensor and subsequently
            incorporated within the Work.
          </li>
        </ul>
        <h3 role="presentation">
          2. Grant of Copyright License. Subject to the terms and conditions of
          this License, each Contributor hereby grants to You a perpetual,
          worldwide, non-exclusive, no-charge, royalty-free, irrevocable
          copyright license to reproduce, prepare Derivative Works of, publicly
          display, publicly perform, sublicense, and distribute the Work and
          such Derivative Works in Source or Object form.
        </h3>
        <h3 role="presentation">
          3. Grant of Patent License. Subject to the terms and conditions of
          this License, each Contributor hereby grants to You a perpetual,
          worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except
          as stated in this section) patent license to make, have made, use,
          offer to sell, sell, import, and otherwise transfer the Work, where
          such license applies only to those patent claims licensable by such
          Contributor that are necessarily infringed by their Contribution(s)
          alone or by combination of their Contribution(s) with the Work to
          which such Contribution(s) was submitted. If You institute patent
          litigation against any entity (including a cross-claim or counterclaim
          in a lawsuit) alleging that the Work or a Contribution incorporated
          within the Work constitutes direct or contributory patent
          infringement, then any patent licenses granted to You under this
          License for that Work shall terminate as of the date such litigation
          is filed.
        </h3>
        <h3 role="presentation">
          4. Redistribution. You may reproduce and distribute copies of the Work
          or Derivative Works thereof in any medium, with or without
          modifications, and in Source or Object form, provided that You meet
          the following conditions:
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(a)&nbsp;</li>
          <li role="presentation">
            You must give any other recipients of the Work or Derivative Works a
            copy of this License; and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(b)&nbsp;</li>
          <li role="presentation">
            You must cause any modified files to carry prominent notices stating
            that You changed the files; and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(c)&nbsp;</li>
          <li role="presentation">
            You must retain, in the Source form of any Derivative Work that You
            distribute, all copyright, patent, trademark, and attribution
            notices from the Source form of the Work,excluding those notices
            that do not pertain to any part of the Derivative Works; and
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">(d)&nbsp;</li>
          <li role="presentation">
            {" "}
            If the Work includes a "NOTICE" text file as part of its
            distribution, then any Derivative Works that You distribute must
            include a readable copy of the attribution notices contained within
            such NOTICE file, excluding those notices that do not pertain to any
            part of the Derivative Works, in at least one of the following
            places: within a NOTICE text file distributed as part of the
            Derivative Works; within the Source form or documentation, if
            provided along with the Derivative Works; or, within a display
            generated by the Derivative Works, if and wherever such third-party
            notices normally appear. The contents of the NOTICE file are for
            informational purposes only and do not modify the License. You may
            add Your own attribution notices within Derivative Works that You
            distribute, alongside or as an addendum to the NOTICE text from the
            Work, provided that such additional attribution notices cannot be
            construed as modifying the License.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            You may add Your own copyright statement to Your modifications and
            may provide additional or different license terms and conditions for
            use, reproduction, or distribution of Your modifications, or for any
            such Derivative Works as a whole, provided Your use, reproduction,
            and distribution of the Work otherwise complies with the conditions
            stated in this License.
          </li>
        </ul>
        <h3 role="presentation">
          5. Submission of Contributions. Unless You explicitly state otherwise,
          any Contribution intentionally submitted for inclusion in the Work by
          You to the Licensor shall be under the terms and conditions of this
          License, without any additional terms or conditions. Notwithstanding
          the above, nothing herein shall supersede or modify the terms of any
          separate license agreement you may have executed with Licensor
          regarding such Contributions.
        </h3>
        <h3 role="presentation">
          6. Trademarks. This License does not grant permission to use the trade
          names, trademarks, service marks, or product names of the Licensor,
          except as required for reasonable and customary use in describing the
          origin of the Work and reproducing the content of the NOTICE file.
        </h3>
        <h3 role="presentation">
          7. Disclaimer of Warranty. Unless required by applicable law or agreed
          to in writing, Licensor provides the Work (and each Contributor
          provides its Contributions) on an "AS IS" BASIS, WITHOUT WARRANTIES OR
          CONDITIONS OF ANY KIND, either express or implied, including, without
          limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT,
          MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely
          responsible for determining the appropriateness of using or
          redistributing the Work and assume any risks associated with Your
          exercise of permissions under this License.
        </h3>
        <h3 role="presentation">
          8. Limitation of Liability. In no event and under no legal theory,
          whether in tort (including negligence), contract, or otherwise, unless
          required by applicable law (such as deliberate and grossly negligent
          acts) or agreed to in writing, shall any Contributor be liable to You
          for damages, including any direct, indirect, special, incidental, or
          consequential damages of any character arising as a result of this
          License or out of the use or inability to use the Work (including but
          not limited to damages for loss of goodwill, work stoppage, computer
          failure or malfunction, or any and all other commercial damages or
          losses), even if such Contributor has been advised of the possibility
          of such damages.
        </h3>
        <h3 role="presentation">
          9. Accepting Warranty or Additional Liability. While redistributing
          the Work or Derivative Works thereof, You may choose to offer, and
          charge a fee for, acceptance of support, warranty, indemnity, or other
          liability obligations and/or rights consistent with this License.
          However, in accepting such obligations, You may act only on Your own
          behalf and on Your sole responsibility, not on behalf of any other
          Contributor, and only if You agree to indemnify, defend, and hold each
          Contributor harmless for any liability incurred by, or claims asserted
          against, such Contributor by reason of your accepting any such
          warranty or additional liability.
        </h3>
        <h1 role="presentation">
          ios logcat, Core RP library, Shader graph, Test Framework, TextMesh
          Pro, Timeline, Unity Collaborate, Universal RP
        </h1>
        <h3 role="presentation">Unity Companion License</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Unity Technologies SF (Unity) grants to you a worldwide,
            non-exclusive, no-charge, and royalty-free copyright license to
            reproduce, prepare derivative works of, publicly display, publicly
            perform, and distribute the work of authorship that accompanies this
            License (Work), subject to the following terms and conditions:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            1. Unity Companion Use. Exercise of the license granted herein is
            permitted as long as it is in connection with theâ€¯ authoring
            and/or distribution of applications, software, or other content
            under a valid Unity content authoring and rendering engine software
            license (Engine License). That means, for example, as long as you
            authored content using the Work under an Engine License, you may
            distribute the Work in connection with that content as you see fit
            under this License. No other exercise of the license granted herein
            is permitted, and in no event may the Work be used for competitive
            analysis or to develop a competing product or service.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            2. No Modification of Engine License. Neither this License nor any
            exercise of the license granted herein modifies the Engine License
            in any way.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">3. Ownership; Derivative Works.</li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            3.1 You own your content. In this License, â€œderivative worksâ€
            means derivatives of the Work itself--works derived only from the
            Work by you under this License (for example, modifying the code of
            the Work itself to improve its efficacy); â€œderivative worksâ€ of
            the Work do not include, for example, games, apps, or content that
            you create with the Work. You keep all right, title, and interest in
            your own content.{" "}
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            3.2 Unity owns its content. While you keep all right, title, and
            interest to your own content per the above, as between Unity and
            you, Unity will own all right, title, and interest to all
            intellectual property rights (including patent, trademark, and
            copyright) in the Work and derivative works of the Work, and you
            hereby assign and agree to assign all such rights in those
            derivative works to Unity. Should assignment be invalid for any
            reason, you grant to Unity an irrevocable, perpetual, worldwide,
            non-exclusive, no-charge, and royalty-free license (with the right
            to grant sublicenses) under those intellectual property rights to
            those derivative works. You also agree to waive or refrain from
            asserting any authorâ€™s right, moral rights, or like rights to the
            extent necessary to permit exploitation as contemplated under this
            License.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            3.3 Your right to use derivative works. You will always have the
            right to use derivative works of the Work you create, consonant with
            this License.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            4. Trademarks. You are not granted any right or license under this
            License to use any trademarks, service marks, trade names, products
            names, or branding of Unity or its affiliates (Trademarks).
            Descriptive uses of Trademarks are permitted; see, for example,
            Unity Trademark Guidelines
            atâ€¯https://unity.com/legal/branding_trademarks.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            5. Notices & Third-Party Rights. This License, including the
            copyright notice associated with the Work, must be provided in all
            substantial portions of the Work and derivative works thereof (or,
            if that is impracticable, in any other location where such notices
            are customarily placed). Further, if the Work is accompanied by a
            Unity â€œthird-party noticesâ€ or similar file, you acknowledge and
            agree that software or content identified in that file is governed
            by those separate license terms.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            6. DISCLAIMER, LIMITATION OF LIABILITY. THE Work AND ANY DERIVATIVE
            WORKS THEREOF IS PROVIDED ON AN "AS IS" BASIS, AND IS PROVIDED
            WITHOUT WARRANTY OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING
            ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
            AND/OR NON-INFRINGEMENT. IN NO EVENT SHALL ANY COPYRIGHT HOLDER OR
            AUTHOR BE LIABLE FOR ANY CLAIM, DAMAGES (WHETHER DIRECT, INDIRECT,
            INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL, INCLUDING
            PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, LOSS OF USE, DATA, OR
            PROFITS, AND BUSINESS INTERRUPTION), OR OTHER LIABILITY WHATSOEVER,
            WHETHER IN AN ACTION OF CONTRACT, TORT, OR OTHERWISE, ARISING FROM
            OR OUT OF, OR IN CONNECTION WITH, THE Work OR ANY DERIVATIVE WORKS
            THEREOF OR THE USE OF OR OTHER DEALINGS IN SAME, EVEN WHERE ADVISED
            OF THE POSSIBILITY OF SUCH DAMAGE.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            7. USE IS ACCEPTANCE and License Versions. Your access to and use of
            the Work constitutes your acceptance of this License and its terms
            and conditions. This License may be modified or updated; upon any
            such modification or update, you will comply with the terms of the
            updated License for any use of any of the Work under the updated
            License.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            8. Use in Compliance with Law and Termination. Your exercise of the
            license granted herein will at all times be in compliance with
            applicable law and will not infringe any proprietary rights
            (including intellectual property rights); this License will
            terminate immediately (i) on any breach by you of this License; and
            (ii) if you commence any form of patent litigation, including a
            cross-claim or counterclaim, against anyone wherein you allege that
            the Work constitutes direct or secondary/indirect patent
            infringement.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            9. Severability. If any provision of this License is held to be
            unenforceable or invalid, that provision will be enforced to the
            maximum extent possible and the other provisions will remain in full
            force and effect.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            10. Governing Law and Venue. This License is governed by and
            construed in accordance with the laws of Denmark, except for its
            conflict of laws rules; the United Nations Convention on Contracts
            for the International Sale of Goods will not apply. If you reside
            (or your principal place of business is) within the United States,
            you and Unity agree to submit to the personal and exclusive
            jurisdiction of and venue in the state and federal courts located in
            San Francisco County, California concerning any dispute arising out
            of this License (â€œDisputeâ€). If you reside (or your principal
            place of business is) outside the United States, you and Unity agree
            to submit to the personal and exclusive jurisdiction of and venue in
            the courts located in Copenhagen, Denmark concerning any Dispute.
          </li>
        </ul>
        <h1 role="presentation">Custom N unit</h1>
        <h3 role="presentation">
          Copyright (c) 2018 Charlie Poole, Rob Prouse
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            The above copyright notice and this permission notice shall be
            included in all copies or substantial portions of the Software.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </li>
        </ul>
        <h1 role="presentation">
          Rider Editor, Visual Studio Code Editor, JetBrains Rider Editor
        </h1>
        <h3 role="presentation">The MIT License (MIT)</h3>
        <h3 role="presentation">Copyright (c) 2019 Unity Technologies</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            The above copyright notice and this permission notice shall be
            included in all copies or substantial portions of the Software.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </li>
        </ul>
        <h1 role="presentation">Unity UI</h1>
        <h3 role="presentation">
          Unity UI Copyright Â© 2015-2020 Unity Technologies ApS ("Unity")
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Licensed under the Unity Companion License for Unity-dependent
            projects (see
            https://unity3d.com/legal/licenses/unity_companion_license).
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            _Unless expressly provided otherwise, the Software under this
            license is made available strictly on an â€œAS ISâ€ BASIS WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. Please review the license
            for details on these and other terms and conditions.
          </li>
        </ul>
        <h1 role="presentation">Infinite-scroll-unity</h1>
        <h3 role="presentation">MIT License</h3>
        <h3 role="presentation">Copyright (c) 2019 Mopsicus</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            The above copyright notice and this permission notice shall be
            included in all copies or substantial portions of the Software.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </li>
        </ul>
        <h1 role="presentation">Sprite</h1>
        <h3 role="presentation">Unity License</h3>
        <h3 role="presentation">copyright Â© 2019 Unity Technologies</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Licensed under the Unity Package Distribution License (see
            https://unity3d.com/legal/licenses/Unity_Package_Distribution_License
            ).
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Unless expressly provided otherwise, the software under this license
            is made available strictly on an â€œAS ISâ€ BASIS WITHOUT WARRANTY
            OF ANY KIND, EXPRESS OR IMPLIED. Please review the license for
            details on these and other terms and conditions.
          </li>
        </ul>
        <h1 role="presentation">2D Sprite</h1>
        <h3 role="presentation">
          com.unity.2d.sprite copyright Â© 2019 Unity Technologies
        </h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Licensed under the Unity Package Distribution License (see
            https://unity3d.com/legal/licenses/Unity_Package_Distribution_License
            ).
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Unless expressly provided otherwise, the software under this license
            is made available strictly on an â€œAS ISâ€ BASIS WITHOUT WARRANTY
            OF ANY KIND, EXPRESS OR IMPLIED. Please review the license for
            details on these and other terms and conditions.
          </li>
        </ul>
        <h1 role="presentation">2D Tilemap Editor</h1>
        <h3 role="presentation">MIT License</h3>
        <h3 role="presentation">Copyright Â© 2009-2020 Eric Woroshow</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            The above copyright notice and this permission notice shall be
            included in all copies or substantial portions of the Software.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY,FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </li>
        </ul>
        <h1 role="presentation">Multiplayer HLAPI</h1>
        <h3 role="presentation">MIT License</h3>
        <h3 role="presentation">Copyright (c) 2020, Unity Technologies</h3>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions:
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            The above copyright notice and this permission notice shall be
            included in all copies or substantial portions of the Software.
          </li>
        </ul>
        <ul className="licences-jiophotos-ios-wrapper-content">
          <li role="presentation">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </li>
        </ul>
      </div>
    </>
  );
};

export default JioPhotosIosLicences;
